import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private logger = new Subject<boolean>();
  private admin = new Subject<boolean>();
  public loggedIn: boolean = false;

  constructor(private http: HttpClient, private router: Router,
  @Inject(PLATFORM_ID) private platformId:Object) { }

  public isLoggedIn(): Observable<boolean> {
    return this.logger.asObservable();
  }

  public login(loginForm: FormData): Observable<any> {
    return this.http.post(`${BASEURL}/auth/login`, loginForm, {
      responseType: 'json'
    }).pipe(
      tap((response: any) => {
        //console.log(response);
        //localStorage.setItem('logged', 'true');
        if(isPlatformBrowser(this.platformId)){
          localStorage.setItem('token', response.token);
          localStorage.setItem('user', JSON.stringify(response.account));
          localStorage.setItem('profile', JSON.stringify(response.profile));
        }
        this.loggedIn = true;
        this.admin.next(response.account.is_admin);
        this.logger.next(this.loggedIn);
      }),
      //catchError(this.handleError<any>('login', []))
    );
  }
  public verifyToken(): Observable<any> {
    return this.http.get(`${BASEURL}/auth/verify_token`, {
      responseType: 'json',
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    })
  }
  public getRoles():Observable<any>{
    return this.http.get(`${BASEURL}/utils/roles.json`,{
      responseType: 'json',
      headers: {'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null}
    });
  }
  public logOut() {
    isPlatformBrowser(this.platformId)?localStorage.clear():null;
    this.loggedIn = false;
    this.logger.next(this.loggedIn);
    this.admin.next(false);
    this.router.navigateByUrl('/login/.');
  }

  public signUp(registerForm: any): Observable<any> {
    return this.http.post<any>(`${BASEURL}/auth/signup`, registerForm, {
      responseType: 'json'
    }).pipe(
      tap((response: any) => {
        /* localStorage.setItem('user', JSON.stringify(response.account));
        localStorage.setItem('token', response.token); */
      }),
      //catchError(this.handleError<any>('signUp', []))
    );
  }

  public passwordRecovery(email: string): Observable<any> {
    return this.http.post<any>(`${BASEURL}/auth/forgot_password`, { email: email }, {
      responseType: 'json'
    }).pipe(
      tap((response: any) => {
        //console.log(response);
      }),
      //catchError(this.handleError<any>('passwordRecovery', []))
    );
  }

  // return if user has google auth connection
  public getHasGoogleAuth(): Observable<any> {
    return this.http.get(`${BASEURL}/auth/has_google`, {
      responseType: 'json',
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    }).pipe(
      tap((response: any) => {
        // console.log(response);
      }),
      catchError(this.handleError<any>('getHasGoogleAuth', []))
    );
  }

  public setGoogleAccount(): Observable<any> {
    return this.http.post(`${BASEURL}/auth/google`, {}, {
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    })
      .pipe(
        tap((response: any) => {
          //console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public removeGoogleAccount(): Observable<any> {
    return this.http.delete(`${BASEURL}/auth/remove_google`, {
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    })
      .pipe(
        tap((response: any) => {
          console.log(response);
        }),
        //catchError(this.handleError<any>('login', []))
      );
  }

  public getTimezones(): Observable<any>{
    return this.http.get(`${BASEURL}/time-zones`)
  }

  public putTimezone(timezone:string): Observable<any>{
    return this.http.put(`${BASEURL}/admin/timezone`, {time_zone:timezone}, {
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    })
  }

  public putMinimumTime(minimum:number): Observable<any>{
    return this.http.put(`${BASEURL}/admin/minimum_lead_time`, {minimum_lead_time: minimum}, {
      headers: {
        'Authorization': isPlatformBrowser(this.platformId)?localStorage.getItem('token'):null
      }
    })
  }

  public userIsUser():string{
    const isUser = isPlatformBrowser(this.platformId)?JSON.parse(localStorage.getItem('user')).is_user:'';
    return isUser;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

}
